import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class SagawaEhidenService {
  private apiUrl = '/play/sagawa/ehiden';

  constructor(private http: HttpService) { }

  get(ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${ownerId}`;
    return this.http.getNoMap(url);
  }

  upload(file: File): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;

    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/sagawa-ehiden/sagawa-ehiden.service.ts